import React from "react";
import SuccessImage from "asset/images/greenSuccess.svg";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "asset/icons";
import { useNavigate } from "react-router-dom";

const RejectShipmentModal = ({ show, setShow, shipmentId, handleRejectShipment }) => {
    const navigate = useNavigate();
    const [note, setNote] = React.useState("");
    const goTo = (shipmentId) => {
        navigate(`/flex/home/manage-shipment?shipmentId=${shipmentId}`);
    };
    return (
        <Modal show={show} contentClassName="!rounded-xl w-full max-w-[453px] mx-auto" centered>
            <div className="flex items-start justify-between p-3">
                <div className="flex items-center gap-x-2">
                    <div className="flex flex-col text-left">
                        <h5>Give reasons for rejection</h5>

                        <p className="mb-2 text-sm font-normal text-main-grey">
                            Please provide a reason for rejecting this request.
                        </p>
                    </div>
                </div>
                <div className="flex items-start justify-center">
                    <CloseIcon
                        onClick={() => setShow(false)}
                        className="!size-4 cursor-pointer text-[#667085] fill-[#667085] stroke-[#667085]"
                    />
                </div>
            </div>
            <section className="px-3 pb-3">
                <textarea
                    value={note}
                    className="bg-[#ECEFF3] h-[100px] resize-none rounded-lg w-full !py-2 !px-4 placeholder:font-normal placeholder:text-sm placeholder:text-main-grey !shadow-[inset_0_0_0_1000px_#ECEFF3]"
                    placeholder="Enter reasons for rejecting rejection reasons"
                    onChange={(evt) => setNote(evt.target.value)}
                />
            </section>
            <footer className="flex items-center justify-end p-3 pt-2 space-y-1 border-t">
                <button
                    onClick={() => setShow(false)}
                    className="flex px-4 py-2 bg-transparent rounded-lg text-main-dark gap-x-2"
                >
                    Cancel
                </button>
                <button
                    className={`w-auto flex px-4 py-2 text-base rounded-lg items-center justify-center border-none outline-none text-white !bg-secondary`}
                    type="button"
                    onClick={() => {
                        console.log("Submit reason:", note, shipmentId);
                        handleRejectShipment({ shipmentId, status: 'accepted' });
                        setNote("");
                        setShow(false);
                    }}
                >
                    Submit Reason
                </button>
            </footer>
        </Modal>
    );
};

export default RejectShipmentModal;
